"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniV2LikeRemoveLiquidityRecipe = void 0;
const uni_v2_like_sdk_1 = require("../../../api/uni-v2-like/uni-v2-like-sdk");
const approve_erc20_spender_step_1 = require("../../../steps/token/erc20/approve-erc20-spender-step");
const uni_v2_like_remove_liquidity_step_1 = require("../../../steps/liquidity/uni-v2-like/uni-v2-like-remove-liquidity-step");
const remove_liquidity_recipe_1 = require("../remove-liquidity-recipe");
const filters_1 = require("../../../utils/filters");
const min_gas_limits_1 = require("../../../models/min-gas-limits");
class UniV2LikeRemoveLiquidityRecipe extends remove_liquidity_recipe_1.RemoveLiquidityRecipe {
    constructor(uniswapV2Fork, lpERC20Info, erc20InfoA, erc20InfoB, slippageBasisPoints, provider) {
        super();
        this.config = {
            name: '[Name] Remove Liquidity',
            description: 'Removes liquidity from a [NAME] Pool.',
            minGasLimit: min_gas_limits_1.MIN_GAS_LIMIT_LP_V2_REMOVE_LIQUIDITY,
        };
        this.uniswapV2Fork = uniswapV2Fork;
        this.lpERC20Info = lpERC20Info;
        this.erc20InfoA = erc20InfoA;
        this.erc20InfoB = erc20InfoB;
        this.slippageBasisPoints = slippageBasisPoints;
        this.provider = provider;
        const forkName = uni_v2_like_sdk_1.UniV2LikeSDK.getForkName(uniswapV2Fork);
        this.config.name = `${forkName} Remove Liquidity`;
        this.config.description = `Removes liquidity from a ${forkName} Pool.`;
    }
    supportsNetwork(networkName) {
        return uni_v2_like_sdk_1.UniV2LikeSDK.supportsForkAndNetwork(this.uniswapV2Fork, networkName);
    }
    async getRemoveLiquidityData(networkName, lpERC20Amount) {
        this.removeLiquidityData = await uni_v2_like_sdk_1.UniV2LikeSDK.getRemoveLiquidityData(this.uniswapV2Fork, networkName, lpERC20Amount, this.erc20InfoA, this.erc20InfoB, this.slippageBasisPoints, this.provider);
        return this.removeLiquidityData;
    }
    async getInternalSteps(firstInternalStepInput) {
        const { networkName, erc20Amounts } = firstInternalStepInput;
        const lpERC20Amount = (0, filters_1.findFirstInputERC20Amount)(erc20Amounts, this.lpERC20Info);
        const removeLiquidityData = await this.getRemoveLiquidityData(networkName, lpERC20Amount);
        return [
            new approve_erc20_spender_step_1.ApproveERC20SpenderStep(removeLiquidityData.routerContractAddress, this.lpERC20Info),
            new uni_v2_like_remove_liquidity_step_1.UniV2LikeRemoveLiquidityStep(this.uniswapV2Fork, removeLiquidityData),
        ];
    }
}
exports.UniV2LikeRemoveLiquidityRecipe = UniV2LikeRemoveLiquidityRecipe;
